import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useNavigate,
} from "react-router-dom";

// PAGES
import GroupChat from "./pages/GroupChat";
import Login from "./pages/Login";
import AccountView from "./pages/Account";
import Admin from "./pages/Admin";

// PUBLIC HELP CENTER
import Help from "./pages/Help";

// PRIVACY POLICY AND TERMS
import {
  privacyPolicy,
  termsOfService,
} from "./pages/privacyPolicy";

// DATABASE MAINTENANCE
import {
  startFeedCacheMaintenance,
} from "./db/feedCacheMaintenance";

import {
  startStatusCleanup,
} from "./db/cleanStatus";

// LEGAL DOCUMENT PAGE
const LegalDocumentPage = ({ title, content }) => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen overflow-y-auto bg-neutral-50 px-4 py-8 text-neutral-900 dark:bg-neutral-900 dark:text-neutral-100">
      <main className="mx-auto w-full max-w-3xl rounded-2xl border border-neutral-200 bg-white p-6 shadow-sm dark:border-neutral-700 dark:bg-neutral-800 sm:p-10">
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="mb-6 text-sm font-medium text-green-600 hover:underline dark:text-green-400"
        >
          ← Back
        </button>

        <h1 className="mb-6 text-2xl font-bold">
          {title}
        </h1>

        <pre className="whitespace-pre-wrap break-words font-sans text-sm leading-7">
          {content.trim()}
        </pre>
      </main>
    </div>
  );
};

// APP ROUTES
const AppRoutes = ({ chatId, setChatId }) => {
  const navigate = useNavigate();

  return (
    <Routes>
      {/* Main application */}
      <Route
        path="/"
        element={
          <GroupChat
            chatId={chatId}
            setChatId={setChatId}
          />
        }
      />

      {/* Groups */}
      <Route
        path="/groups"
        element={
          <GroupChat
            chatId={chatId}
            setChatId={setChatId}
          />
        }
      />

      {/* Login */}
      <Route
        path="/login"
        element={
          <Login
            onLoginSuccess={(screen) => {
              if (screen === "account") {
                navigate("/account");
              } else if (screen === "forgot") {
                navigate("/");
              }
            }}
          />
        }
      />

      {/* Account registration */}
      <Route
        path="/account"
        element={
          <AccountView
            onSignIn={() => navigate("/login")}
          />
        }
      />

      {/* Admin */}
      <Route path="/admin" element={<Admin />} />

      {/* PUBLIC HELP CENTER */}
      <Route
        path="/help"
        element={
          <Help
            onBack={() => navigate(-1)}
          />
        }
      />

      {/* Privacy Policy */}
      <Route
        path="/privacy"
        element={
          <LegalDocumentPage
            title="Privacy Policy"
            content={privacyPolicy}
          />
        }
      />

      {/* Terms of Service */}
      <Route
        path="/terms"
        element={
          <LegalDocumentPage
            title="Terms of Service"
            content={termsOfService}
          />
        }
      />

      {/* Fallback */}
      <Route
        path="*"
        element={
          <GroupChat
            chatId={chatId}
            setChatId={setChatId}
          />
        }
      />
    </Routes>
  );
};

// MAIN APP
const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const [chatId, setChatId] = useState(() =>
    sessionStorage.getItem("chatId")
  );

  useEffect(() => {
    const loggedInStatus =
      localStorage.getItem("isLoggedIn");

    setIsLoggedIn(loggedInStatus === "true");
  }, []);

  /* START IDB MAINTENANCE */
  useEffect(() => {
    startFeedCacheMaintenance();
    startStatusCleanup();
  }, []);

  /* PERSIST CHAT ID */
  useEffect(() => {
    if (chatId) {
      sessionStorage.setItem("chatId", chatId);
    }
  }, [chatId]);

  return (
    <Router>
      <AppRoutes
        chatId={chatId}
        setChatId={setChatId}
      />
    </Router>
  );
};

export default App;